"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiSupplierExtraFieldDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
/**
 * Расширенная, специфичная для конкретного мерчант-провайдера
 * информация о поставщике в формате ключ=значение.
 */
let BillingApiSupplierExtraFieldDto = class BillingApiSupplierExtraFieldDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Наименование поля в форме"
}), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierExtraFieldDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Значение из поля формы",
  nullable: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiSupplierExtraFieldDto.prototype, "value", void 0);
BillingApiSupplierExtraFieldDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiSupplierExtraFieldDto);
exports.BillingApiSupplierExtraFieldDto = BillingApiSupplierExtraFieldDto;
